export const NAVIGATION = 'NAVIGATION'
export const SHOW_ORDER_MANAGEMENT = 'SHOW_ORDER_MANAGEMENT'
export const SHOW_MENU = 'SHOW_MENU'
export const GET_HEIGHT = 'GET_HEIGHT'
export const NAV_PROGRAM_ENTRY = 'NAV_PROGRAM_ENTRY';
export const NAV_VENDOR_ENTRY = 'NAV_VENDOR_ENTRY';
export const NAV_PRODUCT_ENTRY = 'NAV_PRODUCT_ENTRY';
